import Cookies from "js-cookie";
import { $rrj } from "@/utils/rrjutils";

const TokenKey = "Admin-Token";
const localStorage = window.localStorage;
const RefreshTokenKey = "refresh_token";

// access token
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  // 设置了两小时有效期
  // return Cookies.set(TokenKey, token, { expires: 1 / 12 })
  return Cookies.set(TokenKey, token, { expires: 14 });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function getLoginId() {
  const tokenStr = localStorage.getItem(RefreshTokenKey);
  if (tokenStr) {
    const tokenObj = JSON.parse(tokenStr);
    return tokenObj && tokenObj.userId;
  }
  return null;
}

// refresh token
export function getRefreshToken() {
  const tokenStr = $rrj.storage.get("_refresh_token");
  if (tokenStr) {
    const tokenObj = JSON.parse(tokenStr);
    if (tokenObj.exp > new Date() / 1000) {
      return tokenObj.id;
    } else {
      // removeRefreshToken();
    }
  }
  return null;
}

export function setRefreshToken(tokenObj) {
  return localStorage.setItem(RefreshTokenKey, JSON.stringify(tokenObj));
}

export function removeRefreshToken() {
  return localStorage.removeItem(RefreshTokenKey);
}
